import { TableCells } from 'models';

export const maintenanceDashboardTableCells: TableCells[] = [
  {
    id: 'Cooperative.Name',
    label: '##attribute#uds_space#uds_cooperativeid',
    type: 'string',
    canSort: false,
  },
  {
    id: 'Space.Name',
    label: '##attribute#incident#uds_spaceid',
    type: 'string',
    canSort: false,
  },
  {
    id: 'RequestType.Label',
    label: '##attribute#incident#uds_requesttype',
    type: 'string',
    canSort: false,
  },
  {
    id: 'Priority.Label ',
    label: '##attribute#incident#prioritycode',
    type: 'string',
    canSort: false,
  },
  {
    id: 'Title',
    label: '##attribute#task#subject',
    type: 'string',
    canSort: false,
  },
];
